import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import Box from 'ui-box';
import { majorScale } from '.';
import { useStores } from '../stores';
import { IBankDetails } from '../stores/BankDetailsStore';
import { ICurrencyRate } from '../stores/CurrencyStore';
import { Select } from './Select';

export interface ICurrencySelectProps {
  value?: ICurrencyRate['currency'] | null;
  onChange?: (currency: ICurrencyRate['currency']) => void;
  restrictToOwn?: boolean;
}

export const CurrencySelect: React.FC<ICurrencySelectProps> = observer(
  ({ value, onChange, restrictToOwn = true }) => {
    const { currencyStore, bankDetailsStore } = useStores();
    const [currencies, setCurrencies] = useState<ICurrencyRate[]>();
    const [own, setOwn] = useState<IBankDetails[]>();

    useEffect(() => {
      let isSub = true;
      currencyStore.getAll().then(({ items }) => isSub && setCurrencies(items));
      if (restrictToOwn)
        bankDetailsStore.getAll().then(({ items }) => isSub && setOwn(items));
      else {
        setOwn([]);
      }
      return () => {
        isSub = false;
      };
    }, [currencyStore, bankDetailsStore, restrictToOwn]);

    let items = currencies
      ? currencies.map((i) => ({ ...i, id: i.currency }))
      : undefined;

    if (restrictToOwn && items && own) {
      items = items.filter((item) =>
        own.find((o) => o.currency === item.currency)
      );
    }

    return (
      <Select
        placeholder="Valuta"
        noResultsMessage="Valuta blev ikke fundet"
        items={items}
        isLoading={!currencies}
        filterItems={(item, query) =>
          item.currency.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
          item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
        }
        onSelect={(currency) => onChange && onChange(currency.currency)}
        value={items ? value : undefined}
        valueRenderer={(v) => {
          return v.currency;
        }}
        itemRenderer={(item) => (
          <>
            <p>{item.currency}</p>
            <Box
              className="p muted small font-mono"
              marginLeft="auto"
              textAlign="right"
              paddingLeft={majorScale(1)}
            >
              {item.label}
            </Box>
          </>
        )}
      />
    );
  }
);
